import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GenericService } from './generic.service';

@Injectable({
  providedIn: 'root'
})
export class UploadService extends GenericService {
  constructor(http: HttpClient) {
    super(http, 'upload');
  }

  uploadFile(file: File): Observable<any> {
    const formData = new FormData();
    formData.append('file', file);

    return this.http.post(`${this.url_base}/${this.prefixo}`, formData, {
      reportProgress: true,
      observe: 'events'
    });
  }
}